let apiUrl = process.env.VUE_APP_API_STATIC;
let s3Url = process.env.VUE_APP_API_CC + "/getS3";
// process.env.NODE_ENV == "development"
//   ? "/static-config"
//   : process.env.VUE_APP_API_STATIC;

export function getNews() {
  return axios.get(`${apiUrl}/main/news.json`);
}

export function getMainEvents() {
  return axios.get(`${s3Url}?path=main/mainEvents.json`);
}

export function getEvent(eventId) {
  return axios.get(`${s3Url}?path=event/${eventId}/event.json`);
}

export function getSessions(eventId) {
  return axios.get(`${s3Url}?path=event/${eventId}/sessions.json`);
}

export function getProducts(eventId) {
  return axios.get(`${s3Url}?path=event/${eventId}/products.json`);
}

export function getAreas(eventId) {
  return axios.get(`${s3Url}?path=event/${eventId}/ticketAreas.json`);
}
